import { concatClassnames } from "shared/utils/concatClassnames";
import Text from "shared/ui/typography/Text";
import Container from "shared/ui/container";
import { StandardOrderProduct } from "shared/api/middleware-api-client";
import ProductItemSidebar from "entities/product-item-sidebar";
import StandardProductItemSidebar from "entities/standard-product-item-sidebar";

interface SidebarStandardProductsListProps {
  products: StandardOrderProduct[];
}
const SidebarStandardProductsList = ({
  products,
}: SidebarStandardProductsListProps) => {
  return (
    <>
      {products.length ? (
        products.map((product, id) => {
          return (
            <div
              key={`standard-product-${id}`}
              className={concatClassnames(
                "gg-grid gg-grid-cols-12 gg-items-start",
                id !== products.length - 1 && "gg-border-b",
                id !== 0 && "gg-pt-9",
                id !== products.length - 1 ? "gg-pb-9" : "gg-pb-2"
              )}
            >
              <StandardProductItemSidebar product={product} />
            </div>
          );
        })
      ) : (
        <Container className="gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32">
          <Text>Geen products.</Text>
        </Container>
      )}
    </>
  );
};
export default SidebarStandardProductsList;
